const REFRESH_PARAM = "izi-refresh";

// Refresh by GET navigation - never by a reload. A reload repeats the request
// that produced the document, and a product page reached through the
// add-to-cart form is a POST result: the product the app has just removed
// would be added back (browsers ask to "resend" the form).
//
// Without a #fragment the proven mechanism stays: navigating to the current
// href performs a full load.
//
// With a #fragment that navigation would be fragment-only (no request), so
// multi-step checkouts never refreshed. There the target URL gets a one-off
// marker parameter so it differs from the current one: a real load happens,
// the fragment survives (the checkout stays on its step), replace() adds no
// history entry, and the bundle entry strips the marker after load. The
// parameter is appended as a string so the existing query (utm_* and friends)
// is passed through byte for byte.
const refreshPage = () => {
    if (!window.location.hash) {
        window.location.href = window.location.href;
        return;
    }

    const { href, hash } = window.location;
    const base = href.slice(0, -hash.length);
    const separator = base.includes("?") ? "&" : "?";

    window.location.replace(`${base}${separator}${REFRESH_PARAM}=${Date.now()}${hash}`);
};

export { refreshPage, REFRESH_PARAM };
